<div class="root-enlaces-destacados m-t-25 p-t-25 p-b-25">
  <div class="container enlaces-destacados-bloque">
    <div class="row">

      <div class="col-md-12 text-center divBotones">
        <div class>
          <span class="title-enlaces">ENLACES DESTACADOS:</span>
        </div>
        <div>

          <img
            *ngFor="let item of buttons"
            (click)="irEnlace(item.enlace)"
            class="img-enlace-destacado cursor-pointer"
            #enlaceProceso
            (mouseover)="item.isHover=true"
            (mouseout)="item.isHover=false"
            [src]="item.isHover?item.hover:item.icon">

        </div>

      </div>
    </div>
  </div>
</div>
